<template>
  <div>
    <div @click.stop="open = !open">
      <slot name="activator">
        <v-btn fab bottom right color="accent">
          <v-icon>Change</v-icon>
        </v-btn>
      </slot>
    </div>
    <v-dialog scrollable v-model="open" width="800px">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          Change Appointment Date of ID {{ appointment.id }}
        </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pa-2 date-with-time-value">
                  <v-text-field
                    :value="Form.due"
                    readonly
                    mask="date-with-time"
                    label="From"
                    class="date_background"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pa-2 date_From_To">
                  <v-text-field
                    class="date_to"
                    return-masked-value
                    v-model="computedDueDate"
                    @click="openDatePicker()"
                    v-validate="'required'"
                    :error-messages="errors.collect('due')"
                    data-vv-name="due"
                    mask="date-with-time"
                    label="To"
                  ></v-text-field>
                  <v-text-field
                    class="date_to_time"
                    return-masked-value
                    v-model="Form.time"
                    @click="openTimePicker()"
                    v-validate="'required'"
                    :error-messages="errors.collect('due')"
                    data-vv-name="due"
                    mask="date-with-time"
                  ></v-text-field>
                </v-flex>

                <!-- <v-flex xs12 md5>
                  <v-date-picker v-model="Form.date" color="primary"></v-date-picker>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-time-picker v-model="Form.time" format="24hr"></v-time-picker>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-3 pr-5">
          <v-spacer></v-spacer>
          <v-btn text @click="(open = false), resetFormError(null, Form)">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!Form.valid" @click="confirmToCreate">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="isDatePickerOpen" width="400px">
      <v-date-picker v-if="isDatePickerOpen" v-model="Form.date" color="primary"></v-date-picker>
    </v-dialog>
    <v-dialog scrollable v-model="isTimePickerOpen" width="400px">
      <v-time-picker v-if="isTimePickerOpen" v-model="Form.time" format="ampm" color="primary"></v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import moment from 'moment';
import appointmentService from '../services/appointment';
import dateUtil from '../utils/dateTime';
import AppointmentTransformer from '../transformers/appointment';

export default {
  mixins: [formMixin],
  props: {
    appointment: {
      type: Object,
      default() {},
    },
  },
  data() {
    const date = this.appointment
      ? dateUtil.formateDateTimeForDisplay(this.appointment.due, 'DD/MM/YYYY')
      : moment().format('DD/MM/YYYY');
    const time = this.appointment
      ? dateUtil.formateDateTimeForDisplay(this.appointment.due, 'HH:mm')
      : moment().format('HH:mm');
    const dateFormate = this.appointment
      ? dateUtil.formateDateTimeForDisplay(this.appointment.due, 'YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
    return {
      tempDate: null,
      isDatePickerOpen: false,
      isTimePickerOpen: false,
      open: false,
      Form: new Forms({
        data: () => ({
          due: `${date} ${time}`,
          valid: false,
          date: dateFormate,
          time: time,
        }),
        transformToPayload: AppointmentTransformer.changeDueDate,
      }),
    };
  },
  computed: {
    computedDateFormatted() {
      return dateUtil.formatDateTimeFromTimeStamp(this.appointment.appointed_at);
    },
    computedDueDate() {
      return dateUtil.formatDate(this.Form.date);
    },
  },
  watch: {},
  methods: {
    confirmToCreate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Change', 'Are you confirm to change due date?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) this.changeDueDate();
            });
        }
      });
    },
    changeDueDate() {
      let updateObj = {
        due: dateUtil.formatDateTimeForPayload(this.Form.date, this.Form.time),
      };
      appointmentService
        .changeDueDate(this.appointment.id, updateObj)
        .then((newAppointment) => {
          // success callback
          this.open = false;
          this.$emit('success', newAppointment);
          this.$notify({
            title: 'Success',
            text: 'Change due date success!!',
            type: 'success',
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openDatePicker() {
      this.isDatePickerOpen = true;
    },
    openTimePicker() {
      this.isTimePickerOpen = true;
    },
  },
  mounted() {},
  components: {},
};
</script>
<style>
.date_From_To {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
}
.date_From_To .date_to {
  width: 100%;
  max-width: 28%;
  flex: 0 0 28%;
}
.date_From_To .date_to_time {
  width: 100%;
  max-width: 72%;
  flex: 0 0 72%;
}
.date_background .v-input__slot {
  background-color: rgba(0, 0, 0, 0.06);
}
.date_From_To .theme--light.v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot:before {
  border-color: rgba(0, 0, 0, 0.42) !important;
}
.date-with-time-value
  .theme--light.v-text-field:not(.v-input--has-state):hover
  > .v-input__control
  > .v-input__slot:before {
  border-color: rgba(0, 0, 0, 0.42) !important;
}
.v-application .date_From_To .primary--text {
  color: rgba(0, 0, 0, 0.42) !important;
  caret-color: rgba(0, 0, 0, 0.42) !important;
}
.v-application .date-with-time-value .primary--text {
  color: rgba(0, 0, 0, 0.42) !important;
  caret-color: rgba(0, 0, 0, 0.42) !important;
}
</style>
